import { FCX } from '@datassential/platform-ui-lib';
import Button from '@components/new/Button/Button';
import { IconDownloadOutline } from '@icons';
import { useRestaurantOpeningsClosingsExport } from '@apiHooks/useRestaurantOpeningsClosingsExport';
import { useOpeningsClosingsFilters } from './context/OpeningsClosingsFilterContext';
import './OpeningsClosingsExportButton.scss';

const OpeningsClosingsExportButton: FCX = () => {
    const { query, data, isLoading } = useOpeningsClosingsFilters();
    const { requestExport, isExporting } = useRestaurantOpeningsClosingsExport(query);
    const isDisabled = isLoading || data.length === 0;

    return (
        <Button
            className="OpeningsClosingsExportButton"
            modifiers={['icon']}
            onClick={requestExport}
            isLoading={isExporting}
            isDisabled={isDisabled}
            ariaLabel="Download Excel"
            tooltipText="Download Excel"
            testId="buttonOpeningsClosingsExport"
        >
            <IconDownloadOutline aria-hidden focusable="false" />
        </Button>
    );
};

export default OpeningsClosingsExportButton;
